<template>
    <div class="page_">
        <navbar :flag="0"/>
        <div class="con_">
          <img :src="introduceUrl" alt="">
        </div>
        <footbar></footbar>
    </div>
</template>
<style lang="scss" scoped>
.page_ {
    font-size: 12px;
    .con_{
      width:100%;
      margin:0 auto 0;
      img{
        width:100%;
        height:auto;
      }
    }
}
</style>
<script>
import navbar from './components/navbar'
import footbar from './components/footbar'
import api from '@/utils/api'
export default {
    data () {
        document.title = '公司介绍'
        return {
          introduceUrl:'',
        }   
    },
    components: {
        navbar,
        footbar
    },
    mounted () {
      api.getCorePcstore().then(res => res.data).then(data => {
          if(data.returnCode === '0000' && data.data!=''){
              this.introduceUrl=data.data.companyIntroduceUrl
          }
      })
    },
    methods: {
    }
}
</script>